import { render, staticRenderFns } from "./CRating.vue?vue&type=template&id=9e89a5a0&scoped=true&"
import script from "./CRating.vue?vue&type=script&lang=js&"
export * from "./CRating.vue?vue&type=script&lang=js&"
import style0 from "./CRating.vue?vue&type=style&index=0&id=9e89a5a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e89a5a0",
  null
  
)

export default component.exports